import store from "@/store/store.js"
const notificationMp3Url = 'https://clean-code.s3.amazonaws.com/pedbot/audio/1602539353pIJu27ef68.mp3'

export default {
    SET_CHAT_CONTACTS(state, { concatResults, items }) {
        if (concatResults) {
            state.chatContacts = [
                ...state.chatContacts,
                ...items
            ]
        } else {
            state.chatContacts = items
        }
        
    },
    SET_CHAT_CONTACT_INFOS(state, chatContactInfos) {
        state.chatContactInfos = chatContactInfos
    },
    CHANGE_SELECTED_CUSTOMER(state, { customerId, instanceId }) {
        state.selectedCustomerChats.customerId = customerId
        state.selectedCustomerChats.instanceId = instanceId
    },
    PREPEND_SELECTED_CUSTOMER_CHATS(state, { customerId, customerChats }) {
        if (customerChats.length <= 0) {
            return;
        }

        if (customerId !== state.selectedCustomerChats.customerId) {
            return;
        }

        state.selectedCustomerChats.chats = [
            ...customerChats,
            ...state.selectedCustomerChats.chats
        ]
    },
    SET_SELECTED_CUSTOMER_CHATS(state, { customerId, customerChats }) {
        // state.selectedCustomerChats.customerId = customerId
        if (customerId === store.state.chatContact.selectedCustomerChats.customerId) {
            state.selectedCustomerChats.chats = customerChats
            const chatIndex = state.chatContacts.findIndex((c) => c.id === customerId)
            
            if (chatIndex >= 0) {
                let unseenMsg = 0
                for (const customerChat of customerChats) {
                    if (customerChat.unseen_msg && customerChat.type == 1) {
                        unseenMsg += 1
                    }
                }
                state.chatContacts[chatIndex].unseenMsg = unseenMsg
            }
        }
    },
    UPDATE_CHAT_CONTACT(state, chatContact) {
        const chatIndex = state.chatContacts.findIndex((c) => c.id === chatContact.id)
        state.chatContacts[chatIndex] = chatContact
    },
    UPDATE_RESEARCH(state, {chatId, active}) {
        const chatIndex = state.chatContacts.findIndex((c) => c.id === chatId)
        const chatTicket = state.chatContacts[chatIndex];
        chatTicket.customerLastChat.chatTicket.is_research = active
        state.chatContacts[chatIndex] = chatTicket
    },
    CHAT_NOTIFICATION() {
        // TODO: Colocar o chat para subir para primeira posição na listagem
        /*const chatIndex = state.chatContacts.findIndex((c) => c.id === customerId)
        const currentChat = state.chatContacts[chatIndex]
        delete state.chatContacts[chatIndex]

        state.chatContacts = [
            ...[ currentChat ],
            ...state.chatContacts
        ]*/

        const notificationSound = new Audio(notificationMp3Url)
        notificationSound.play()
    },
    CONCAT_SELECTED_CUSTOMER_CHATS(state, { customerId, instanceId, customerChat }) {
        if (
            customerId === state.selectedCustomerChats.customerId &&
            instanceId === store.state.instance.selectedInstance
        ) {
            state.selectedCustomerChats.chats = [
                ...state.selectedCustomerChats.chats,
                customerChat
            ]

            state.selectedCustomerChats.chats
                .sort((a, b) => 
                    new Date(a.sent_at).getTime() - new Date(b.sent_at).getTime()
                )
        }
    },
    CHANGE_CONTACT_LAST_MESSAGE (state, customerChat) {
        const customerId = customerChat.customer_id
        const unseenMsg = customerChat.unseenMsg
        delete customerChat.customer_id
        const chatIndex = state.chatContacts.findIndex((c) => c.id === customerId)
        delete customerChat.unseenMsg
        if (state.chatContacts[chatIndex] !== undefined) {
            state.chatContacts[chatIndex].customerLastChat = customerChat

            // Only sum if the message is from received type
            if (customerChat.type === 1 && unseenMsg) {
                state.chatContacts[chatIndex] = {
                    ...state.chatContacts[chatIndex],
                    unseenMsg: state.chatContacts[chatIndex].unseenMsg + 1
                }
            }
        }
    },

    PUT_CONTACT_AT_THE_TOP (state, {
        chatContact,
        inbox = false,
        olderInboxChatsFirst = false,
        isAdminUser = false
    }) {
        const chatIndex = state.chatContacts.findIndex((c) => c.id === chatContact.id)
        if (chatIndex >= 0) {
            state.chatContacts.splice(chatIndex, 1)
        }


        state.customersToRemoveIds = state.chatContacts.map((chatContact) => chatContact.id);
    },
    CHANGE_CUSTOMER_CHAT_ACK (state, customerChat) {
        if (customerChat.customer_id === state.selectedCustomerChats.customerId) {
            const chat = state.selectedCustomerChats.chats.find((c) => c.id === customerChat.id);

            if (chat && (chat.ack === null || chat.ack <= customerChat.ack)) {
                chat.ack = customerChat.ack;
            }
        }
    },
    RESET_CUSTOMERS_TO_REMOVE_IDS (state) {
        state.customersToRemoveIds = []
    },
    RESET_UNSEEN_MESSAGE (state, customerId) {
        const chatIndex = state.chatContacts.findIndex((c) => c.id === customerId)
        if (state.chatContacts[chatIndex] !== undefined) {
            state.chatContacts[chatIndex].unseenMsg = 0
        }
    },
    CONCAT_CHAT_CONTACT (state, {
        customer,
        inbox = false,
        olderInboxChatsFirst = false
    }) {
        const customerIndex = state.chatContacts.findIndex((c) => c.id === customer.id)
        if (customerIndex >= 0) {
            state.chatContacts[customerIndex].name = customer.name
            state.chatContacts[customerIndex].image = customer.image
            return;
        }

        let chatContacts = [{ ...customer, inbox }, ...state.chatContacts];

        if (!olderInboxChatsFirst) {
            state.chatContacts = chatContacts.map((chatContact) => {
                return { ...chatContact, pickableInboxChat: inbox };
            });
            return;
        }

        state.chatContacts = chatContacts.sort((a, b) => {
            const createdAtA = new Date(a.createdAt);
            const createdAtB = new Date(b.createdAt);
            if (createdAtA === createdAtB) {
                return 0;
            }

            return createdAtA < createdAtB ? 1 : -1;
        }).map((chatContact, index) => {
            return index === 0
                ? { ...chatContact, pickableInboxChat: inbox }
                : { ...chatContact, pickableInboxChat: inbox && !olderInboxChatsFirst }
        });
    },
    CUSTOMER_BLACKLISTED (state, customerId) {
        const customerIndex = state.chatContacts.findIndex((c) => c.id === customerId)

        if (customerIndex >= 0) {
            state.chatContacts[customerIndex].is_blacklisted = true
        }
    },
    SOCKET_WAS_LISTENED(state) {
        state.isSocketAlreadyListened = true
    },
    APPEND_LAST_SENT_MESSAGE_TEMPORARILY(state, {
        message = '',
        tempMessages = [],
        docName = null,
        isDoc = false,
        customerId
    }) {
        if (customerId === store.state.chatContact.selectedCustomerChats.customerId) {
            let tempId = 0;

            if (state.selectedCustomerChats.chats.length > 0) {
                let lastCustomerChatId = state.selectedCustomerChats.chats[state.selectedCustomerChats.chats.length - 1].id

                if (typeof lastCustomerChatId === 'string') {
                    lastCustomerChatId = parseInt(lastCustomerChatId.replace('-temp', ''))
                }
                tempId = lastCustomerChatId + 1
            }

            const datetime = new Date()

            let tag_type = 'stop_flow'

            if (isDoc) {
                const eventTypes = {
                    jpg: 'image',
                    jpeg: 'image',
                    gif: 'image',
                    pdf: 'pdf',
                    vnd: 'doc',
                    ogg: 'audio',
                    mp4: 'video',
                    mov: 'video',
                    mpe: 'audio',
                    mpeg: 'image',
                    png: 'image',
                    web: 'sticker',
                    webp: 'sticker',
                    xml: 'doc',
                    pla: 'doc',
                    csv: 'doc',
                    msw: 'doc',
                    doc: 'doc',
                    docx: 'doc',
                    xls: 'doc',
                    xlsx: 'doc',
                    mp3: 'audio'
                }

                const splitedUrl = message.split('.')
                tag_type = eventTypes[splitedUrl[splitedUrl.length - 1]]

                if (tag_type === undefined) {
                    tag_type = 'doc'
                }
            }

            const temporarilyMessages = tempMessages.length ? tempMessages : ( message !== ''
                ? [{
                    'id': `${tempId}-temp`,
                    'type': 0,
                    'sent_at': datetime.toISOString(),
                    'message': message,
                    'tag_type': tag_type,
                    'unseen_msg': false,
                    'document_name': docName,
                    'document_mimetype': null,
                    'chatTicket': null,
                    'is_temp': true,
                    'is_bot_message': false
                }]
                : []
            )

            state.selectedCustomerChats.chats = [
                ...state.selectedCustomerChats.chats,
                ...temporarilyMessages
            ]
        }
    },
    REMOVE_TEMPORARILY_MESSAGE(state, { tempMessageToRemove }) {
        const selectedCustomerChats = state.selectedCustomerChats.chats.filter(chat => 
            chat.id !== tempMessageToRemove.id
        )

        state.selectedCustomerChats.chats = selectedCustomerChats
    },
    APPEND_TRANSFERRED_CHAT(state, transferredChat) {
        state.transferredChats = [
            ...[ transferredChat ],
            ...state.transferredChats
        ]
    },
    CLEAR_TRANSFERRED_CHATS(state) {
        state.transferredChats = []
    },
    INBOX_MESSAGING_STATUS(state, status) {
        state.inboxMessagesStatus = status;
    },
    CHAT_TAB(state, tab) {
        state.chatTab = tab;
    },
    SET_CHAT_CONTACT_DROPDOWN(state, chatContact) {
        state.chatContactDropdown = chatContact;
    },
    SET_STATUS_ATTENDANCE_POPUP(state, status) {
        state.attendancePopupIsActive = status;
    },
    SET_CHAT_PICKING_POPUP(state, chatContact) {
        state.chatPickingPopup = chatContact;
    },
    SET_STATUS_PICKING_POPUP(state, status) {
        state.pickingPopupIsActive = status;
    },
    SET_CHAT_FINALIZE_POPUP(state, chatContact) {
        state.chatFinalizePopup = chatContact;
    },
    SET_STATUS_FINALIZE_POPUP(state, status) {
        state.finalizePopupIsActive = status;
    },
    SET_CHAT_TRANSFER_POPUP(state, chatContact) {
        state.chatTransferPopup = chatContact;
    },
    SET_STATUS_TRANSFER_POPUP(state, status) {
        state.transferPopupIsActive = status;
    },
    CHAT_FILTER(state, filter) {
        state.chatFilter = filter;
    },
    ADDITIONAL_CHAT_FILTER(state, filter) {
        state.additionalChatFilter = filter;
    },
    GROUPS_SELECTED_FILTER(state, groupIds) {
        state.groupsSelectedFilter = groupIds;
        localStorage.setItem("groupsSelectedFilter", JSON.stringify(groupIds))
    },
    GET_IN_STORAGE_GROUPS_SELECTED_FILTER(state) {
        const storage = localStorage.getItem('groupsSelectedFilter');
        if ( storage ){ state.groupsSelectedFilter = JSON.parse(storage) }
    },
    REMOVE_CHAT_CONTACT(state, { chatFilter, chatContact }) {
        if ( chatFilter !== 'campaign' ){
            return;
        }

        // Remove o contato da listagem 
        let chatIndex = state.chatContacts.findIndex((c) => {
            return c.id === chatContact.id
        });

        if (chatIndex !== -1){
            state.chatContacts.splice(chatIndex, 1);
        }
    }
}
